/**
 * What to show when a settings action is refused or fails.
 *
 * The API layer rejects with the response body alone. A refusal the backend
 * handles (a 409) carries its reason in `error` — or `reason` — and that is the
 * sentence the admin needs. An unhandled server fault arrives as API Gateway's
 * `{"message": "Internal server error"}`, which says nothing to them, so that
 * placeholder is replaced by the action's own fallback rather than shown.
 */
const GATEWAY_PLACEHOLDERS = new Set(["Internal server error", "Internal Server Error"]);

export function actionErrorMessage(e: unknown, fallback: string): string {
  if (typeof e === "string" && e.trim()) return e;
  const body = e as { reason?: unknown; error?: unknown; message?: unknown } | undefined;
  for (const candidate of [body?.reason, body?.error, body?.message]) {
    if (typeof candidate === "string" && candidate.trim() && !GATEWAY_PLACEHOLDERS.has(candidate.trim())) {
      return candidate;
    }
  }
  return fallback;
}
